/* eslint-disable */
export default {
  title: 'Histórico',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
